export default {
  __html: `<g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3">
                <path d="M19.516 2L2 19.516M2 2l17.516 17.516"/>
            </g>`
}
